import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export interface ImportRowError {
  rowNumber: number;
  identifier: string;
  reason: string;
}
export interface ImportSummary {
  totalRows: number;
  successCount: number;
  failedCount: number;
  errors: ImportRowError[];
}

const downloadBlob = (blob: Blob, filename: string) => {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

// ---- Download sample template ----
export const useDownloadLeaveTemplate = () =>
  useMutation<void, AxiosError>(
    async () => {
      const res = await customAxios.get("/reports/leaves/import/template", {
        responseType: "blob",
      });
      downloadBlob(res.data as Blob, "Leave_Import_Template.xlsx");
    },
    {
      onError: () =>
        showNotification({
          title: "Download failed",
          message: "Could not download the template.",
          color: "red",
        }),
    }
  );

// ---- Upload filled template + execute import ----
const importLeave = async (file: File): Promise<ImportSummary> => {
  const formData = new FormData();
  formData.append("file", file);
  const { data } = await customAxios.post<{ success: boolean; data: ImportSummary }>(
    "/reports/leaves/import",
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
  return data.data;
};

export const useImportLeaveReport = () =>
  useMutation<ImportSummary, AxiosError, File>(importLeave, {
    onError: (error) =>
      showNotification({
        title: "Import failed",
        message:
          (error?.response?.data as any)?.message ||
          "Could not import the file.",
        color: "red",
      }),
  });
